<template>
  <transition mode="out-in">
    <div
      id="cp-sidebar"
      class="v-sidebar-menu menu-tree container-fluid"
      :class="{'collapsed':isCollapsed || $mq !== 'desktop'}"
    >
      <div class="pt-3 pb-1 ml-1">
        <div class="row">
          <div class="col-12" v-if="!isCollapsed && $mq === 'desktop'">
            <h5 class="font-weight-bold">
              <i class="fas fa-file-contract fa-lg pr-2"></i>
              {{title}}
            </h5>
          </div>
          <div
            v-else
            class="px-1 pb-1 ml-1 d-flex justify-content-center my-auto mobile-bg"
            @click="showDropdown=!showDropdown"
          >
            <i class="px-1 mb-2 fas fa-file-contract fa-lg"></i>
          </div>
        </div>
      </div>
      <hr v-if="!isCollapsed && $mq === 'desktop'" width="99%" class="my-0 bg-secondary" />
      <div v-if="!isCollapsed && $mq === 'desktop'">
        <div v-for="(menuItem, index) in menu" :key="index">
          <menu-item
            :menuItem="menuItem"
            :menu="menu"
            :isCollapsed="isCollapsed"
            @item-selected="onMenuItemClick"
            :isOpen="menuItem.contract.Id == activeContract.Id"
            :expandAll="menuItem.contract.Id == activeContract.Id"
          />
        </div>
      </div>
      <dropdown :menu="menu" @item-selected="onMenuItemClick" v-else-if="showDropdown" />
      <button class="collapse-btn" @click="toggleCollapse" v-if="$mq === 'desktop'"></button>
    </div>
  </transition>
</template>

<script>
import MenuItem from "./MenuItem";
import { _ } from "underscore";
import moment from "moment";

// Mixins
import contractsMixin from "@/mixins/contracts/contracts";

export default {
  name: "sidebar-menu",
  mixins: [contractsMixin],
  data() {
    return {
      isCollapsed: false,
      showDropdown: false,
    };
  },
  components: {
    MenuItem,
  },
  props: {
    title: String,
  },
  computed: {
    menu() {
      let menu = [];

      this.contracts.forEach((contract) => {
        menu.push(this.convertContractToMenuItem(contract));
      });

      return menu;
    },
  },

  methods: {
    convertContractToMenuItem(contract) {
      let menuItem = {
        title:
          moment(contract.StartDate).format("DD.MM.YYYY") +
          " - " +
          moment(contract.EndDate).format("DD.MM.YYYY"),
        icon: "fas fa-chevron-right",
        contract: contract,
        pointer: true,
        child: [],
      };

      let serviceBundles = contract.ServiceBundles;
      let gasServices = _.sortBy(_.where(contract.Services, { ServiceType: "Gas" }), 'EffectiveTo');
      let elecServices = _.sortBy(_.where(contract.Services, {
        ServiceType: "Electricity",
      }), 'EffectiveTo');

      if (serviceBundles.length > 0) {
        menuItem.child.push(
          this.convertServiceBundlesToMenuItem(this.orderByEffectiveFrom(serviceBundles))
        );
      }

      if (gasServices.length > 0) {
        menuItem.child.push(
          this.convertGasServicesToMenuItem(gasServices, contract.Id)
        );
      }

      if (elecServices.length > 0) {
        menuItem.child.push(this.convertElecServicesToMenuItem(elecServices));
      }

      return menuItem;
    },

    convertServiceBundlesToMenuItem(serviceBundles) {
      let menuItem = {
        title: "Service Bundles",
        icon: "fas fa-chevron-right",
        pointer: false,
        child: [],
      };

      serviceBundles.forEach((bundle) => {
        menuItem.child.push({
          title: bundle.ServiceBundleName,
          serviceBundle: bundle,
          pointer: true,
        });
      });

      return menuItem;
    },

    convertGasServicesToMenuItem(services, contractId) {
      let menuItem = {
        title: "Gas Services",
        icon: "fas fa-chevron-right",
        pointer: false,
        child: [],
      };

      services.forEach((service) => {
        menuItem.child.push(
          this.convertGasServiceToMenuItem(service, contractId)
        );
      });

      return menuItem;
    },

    convertElecServicesToMenuItem(services, contractId) {
      let menuItem = {
        title: "Electricity Services",
        icon: "fas fa-chevron-right",
        pointer: false,
        child: [],
      };

      services.forEach((service) => {
        menuItem.child.push(
          this.convertElecServiceToMenuItem(service, contractId)
        );
      });

      return menuItem;
    },

    convertGasServiceToMenuItem(service, contractId) {
      let menuItem = {
        title: service.ServiceIdentifier,
        icon: "fas fa-chevron-right",
        pointer: true,
        contractId: contractId,
        service: service,
        child: [],
      };
      menuItem.child.push(
        this.convertCommercialConfigsToMenuItem(
          service.GasDetails.CommercialConfigurations
        )
      );
      return menuItem;
    },

    convertElecServiceToMenuItem(service, contractId) {
      let menuItem = {
        title: service.ServiceIdentifier,
        icon: "fas fa-chevron-right",
        pointer: true,
        contractId: contractId,
        service: service,
        child: [],
      };
      menuItem.child.push(
        this.convertCommercialConfigsToMenuItem(
          service.ElectricityDetails.CommercialConfigurations
        )
      );
      return menuItem;
    },

    convertCommercialConfigsToMenuItem(commercialConfigurations) {
      let menuItem = {
        title: "Commercial Configurations",
        icon: "fas fa-chevron-right",
        pointer: false,
        child: [],
      };

      commercialConfigurations.forEach((config) => {
        menuItem.child.push(this.convertCommercialConfigToMenuItem(config));
      });

      return menuItem;
    },

    convertCommercialConfigToMenuItem(config) {
      let title = config.hasOwnProperty("EffectiveTo")
        ? moment(config.EffectiveFrom).format("DD.MM.YYYY") +
          " - " +
          moment(config.EffectiveTo).format("DD.MM.YYYY")
        : moment(config.EffectiveFrom).format("DD.MM.YYYY") + " - Present";

      return {
        title: title,
        commercialConfig: config,
        pointer: true,
      };
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit("toggle-collapse", this.collapsed);
    },

      onMenuItemClick(items) {
      let contract, bundle, service, config;

      contract = _.find(items, (item) => {
        return item.hasOwnProperty("contract");
      });
      bundle = _.find(items, (item) => {
        return item.hasOwnProperty("serviceBundle");
      });
      service = _.find(items, (item) => {
        return item.hasOwnProperty("service");
      });
      config = _.find(items, (item) => {
        return item.hasOwnProperty("commercialConfig");
      });

      if (contract) {
        this.activeSection = "Contract";
        this.breadcrumbItems = ["Contract"];
        this.activeContract = contract.contract;
      } else {
        this.activeContract = null;
      }

      if (service) {
        if (service.service.ServiceType === "Gas") {
          this.activeSection = "GasService";
          this.breadcrumbItems = ["Contract", "GasService"];
        } else if (service.service.ServiceType === "Electricity") {
          this.activeSection = "ElectricityService";
          this.breadcrumbItems = ["Contract", "ElectricityService"];
        }
        this.activeService = service.service;
      } else {
        this.activeService = null;
      }

          this.$store.commit('resetEditModes');

          if (bundle) {
              this.activeSection = "ServiceBundle";
              this.breadcrumbItems = ["Contract", "ServiceBundle"];
              this.activeBundle = bundle.serviceBundle;
          } else {
              this.activeBundle = null;
          }

      if (config) {
        this.activeSection = "CommercialConfig";
        this.breadcrumbItems = ["Contract", "GasService", "CommercialConfigs"];
        if (this.activeService.ServiceType === "Electricity")
          this.breadcrumbItems[1] = "ElectricityService";
        this.activeCommercialConfig = config.commercialConfig;
      } else {
        this.activeCommercialConfig = null;
      }
    },

    
    orderByEffectiveFrom(collection) {
      return this.$_.sortBy(collection, function(item) {
        return item.EffectiveFrom;
      }).reverse();
    },
  },
};
</script>
